export default __webpack_public_path__ + "static/media/yggdrasil.669e2bd7.png";